export const summaryRoute = 'my-chart/summary';
export const summarySequence = 'summarySequence';
export const encounterSequence = 'encounterSequence';
